import {mapState, type Module} from 'vuex';
import actions from './actions';
import mutations from './mutations';

// state
const state: FormState = {
    errors: {},
    filter: {},
    validated: {},
    submitted: false,
};

// module
const form: Module<FormState, RootState> = {
    namespaced: true,
    state,
    ...mapState('form', [
        'errors',
        'filter',
        'validated',
        'submitted',
    ]),
    actions,
    mutations,
};

export default form;